import { Component } from '@angular/core';

import { environment } from '@environments';

@Component({
  selector: 'pub-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent {
  deployURL = environment.deployURL;
}
